module.exports = __webpack_public_path__ + "img/Slide4.dd6c09be.png";